<template>
	<div class="home">
		<div class="banner"></div>
		<div class="wrapper">
			<div class="attestation">
				<img class="attestation-icon" src="../assets/img/attestation-icon.png" />
				<span>解放轻卡官方认证</span>
			</div>
			<div class="content">
				<div class="text">
					<span>您购买的商品为</span>
					<h3>解放轻卡原厂正品</h3>
					<img class="quality-icon" src="../assets/img/quality.png" />
				</div>
				<div class="active">
					<div class="title">
						<img class="title-bg" src="../assets/img/title-bg.png" />
						<span>活动规则</span>
					</div>
					<div class="con">
						<p>轻卡服务站、备品经销商每销售一桶轻卡活动油品，即可领取价值10元油品销售红包。</p>
						<p>活动时间：2022.5.1-2022.10.31</p>
					</div>
				</div>
				<div class="process">
					<div class="title">
						<img class="title-bg" src="../assets/img/title-bg.png" />
						<span>领取流程</span>
					</div>
					<div class="con">
						<div class="process-item">
							<div class="icon">1</div>
							<div class="process-item-con">
								扫描二维码
							</div>
						</div>
						<!-- <div class="tips">扫描说明：请从左到右依次扫描两个二维码。</div> -->
						<!-- <div class="examples">
							<div class="examples-item">
								<img src="../assets/img/examples-img03.jpg" />
								<span>二维码扫描成功示例图</span>
							</div>
						</div> -->
						<!-- <img class="down-img" src="../assets/img/down.png"/> -->
						<div class="process-item">
							<div class="icon">2</div>
							<div class="process-item-con">
								上传红包二维码、油品照片
							</div>
						</div>
						<!-- <div class="examples">
							<div class="examples-item">
								<img src="../assets/img/examples-img01.jpg" />
								<span>红包二维码示例图</span>
							</div>
							<div class="examples-item">
								<img src="../assets/img/examples-img02.jpg" />
								<span>油品示例图</span>
							</div>
						</div> -->
						<div class="process-item">
							<div class="icon">3</div>
							<div class="process-item-con">
								照片核实中(24小时内核实完毕)
							</div>
						</div>
						<div class="process-item">
							<div class="icon">4</div>
							<div class="process-item-con">
								点击领取红包
							</div>
						</div>
					</div>
				</div>
				<el-button type="primary" class="main-btn" @click="receive" v-loading.fullscreen.lock="!token">点击领取现金红包
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    name: 'Home',
    data(){
      return{
          scanResult:'',
          token: ''
      }
    },
    components: {},
    methods: {
      receive() {
         this.$router.push('/infoForm')
      },
      getUrlKey(name) { //获取url 参数
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      getToken(code) {
        this.$http.fetchGet("/api/wx/wxcallback/" + code, {}).then((res) => {
          if (res.data.code === 0) {
              var token = res.data.token
              localStorage.setItem("token", token)
              this.token = token
          }
        });
      },
    },
    created() {
        let _userInfo = localStorage.getItem("userInfo")

        if (!_userInfo && !this.global.debug) {
            let userInfo = this.getUrlKey("userinfo")
            if(!userInfo) {
                window.location.href = "https://www.yaoyaola.net/exapi/check_user/10811882?url=" + this
                    .global
                    .url + "/&flag=1"
            }else{
                localStorage.setItem("userInfo", userInfo)
            }
        }

        let token = localStorage.getItem('token')
        if(!token) {
            var code = this.getUrlKey('code');
            if (code === null) {
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.global.wxAppId + "&redirect_uri=" + this.global.url + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
            } else {
                this.getToken(code)
            }
        }
        this.token = token
    }
  }
</script>

<style lang="scss">
	//scss
</style>
